import { useQuery } from '@tanstack/react-query'
import { validateAmountOnCommercialCredit } from 'api/mdl14/mdl14.services'
import { companiesCodeOracle, BLOCK_LABELS } from 'Utils/constants'
import { QUERY_KEYS } from 'Utils/queryKeys'

export const useCreditAccountValidation = account => {
  const accountNumber = account?.CreditAccountNumber
  const companyCode =
    companiesCodeOracle[account?.CompanyId?.toUpperCase()] || '01'

  const query = useQuery({
    queryKey: [
      QUERY_KEYS.CREDIT_ACCOUNT_VALIDATION,
      accountNumber,
      companyCode,
    ],
    queryFn: async () => {
      const response = await validateAmountOnCommercialCredit({
        product: 'oracle-credit-commercial-customer',
        no_cia: companyCode,
        no_cliente: accountNumber,
      })
      return (response?.data?.Data ?? response)?.cuentas?.[0] ?? null
    },
    enabled: !!accountNumber,
    staleTime: 1000 * 60 * 5,
    cacheTime: 1000 * 60 * 10,
    retry: false,
  })

  const cuenta = query.data
  const blockMessage = cuenta?.bloqueado
    ? BLOCK_LABELS[cuenta.bloqueado]?.message ||
      cuenta.etiqueta_bloqueado ||
      cuenta.bloqueado
    : null

  return {
    isLoading: query.isFetching,
    blockMessage,
  }
}
